export default function DellerSubscrib(){
    return(<>
    <h1>DellerSubscrib</h1>
    </>);
    }